import { useOnboardingAction } from '@hooks'
import { OnboardingActions, OnboardingStatuses, useMerchantQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import type { HTMLAttributes } from 'react'
import WarningHeader from './WarningHeader'

import './AccountWarning.scss'

interface Props extends HTMLAttributes<HTMLDivElement> {}

function AccountWarning({ ...rest }: Props) {
  const { merchant } = useMerchantQry()
  const { onboardingAction, startOrContinueOnboarding } = useOnboardingAction()

  switch (onboardingAction) {
    case OnboardingActions.NOT_STARTED:
    case OnboardingActions.ONBOARDING:
    case OnboardingActions.DOCUMENTS:
    case OnboardingActions.QUESTIONNAIRE:
      return (
        <div className='account-warning' {...rest}>
          <WarningHeader />
          <div className='mb-2'>
            {tr(
              'PORTAL.COMPONENTS.ACCOUNT_WARNING.NOT_STARTED',
              'Complete your account verification to get access to all features and increased payment limits. Crypto operations are available only.'
            )}
          </div>
          <Button
            type='button'
            color='alternative'
            text={tr('PORTAL.COMPONENTS.ACCOUNT_WARNING.PROCEED_BUTTON', 'Click here to proceed')}
            onClick={startOrContinueOnboarding}
            data-test='proceed-button'
          />
        </div>
      )

    case OnboardingActions.APPLICATION_FEE:
      return (
        <div className='account-warning' {...rest}>
          <WarningHeader />
          <div className='mb-2'>
            {tr(
              'PORTAL.COMPONENTS.ACCOUNT_WARNING.ACCOUNT_PAYMENT',
              'You need to pay your application fee to enable your primary account.'
            )}
          </div>
          <Button
            type='button'
            color='primary'
            text={tr('...PAY_NOW_BUTTON', 'Pay now')}
            onClick={startOrContinueOnboarding}
            data-test='button-pay-now'
          />
        </div>
      )

    case OnboardingActions.UNDER_REVIEW:
      return (
        <div className='account-warning' {...rest}>
          <WarningHeader />
          <div>
            {tr('PORTAL.COMPONENTS.ACCOUNT_WARNING.UNDER_REVIEW', 'Your account verification is under review.')}
          </div>
        </div>
      )

    default:
      if (merchant?.onboardingStatus === OnboardingStatuses.REJECTED_FINAL) {
        return (
          <div className='account-warning' {...rest}>
            <WarningHeader />
            <div>
              {tr(
                'PORTAL.COMPONENTS.ACCOUNT_WARNING.REJECTED',
                'Please contact Customer Service to get support on your account verification.'
              )}
            </div>
          </div>
        )
      }
  }

  return null
}

export default AccountWarning
